module.exports = __webpack_public_path__ + "static/media/berkeley@3x.7f8d086a.png";